<template>
  <div class="deletion-icon-wrapper">
    <i class="fas fa-user-slash deletion-icon"></i>
  </div>
</template>

<script>
export default {
  name: 'DataDeletionIcon'
}
</script>

<style scoped>
.deletion-icon-wrapper {
  width: 120px;
  height: 120px;
  margin: 0 auto 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 50%;
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.25);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  animation: fadeInUp 0.8s ease-out;
}

.deletion-icon {
  font-size: 3.5rem;
  color: #ffffff;
  opacity: 0.95;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
  .deletion-icon-wrapper {
    width: 100px;
    height: 100px;
  }

  .deletion-icon {
    font-size: 2.8rem;
  }
}
</style>
